export function displayError(msg: string, log?: any): void {
    let errorBox = document.getElementById('errorBox');
    if (errorBox) {
        errorBox.style.display = 'block';
    }
    let errorMessageBox = document.getElementById('errorMessageBox');
    if (errorMessageBox) {
        errorMessageBox.innerHTML = msg;
    }

    if (log && console.log) {
        console.log(log);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/animations/message.ts